import React from 'react';
import styled from 'styled-components';
import List from '@ingka/list';
import Hyperlink from '@ingka/hyperlink';
import SSRIcon from '@ingka/ssr-icon';
import arrowLevelDown from '@ingka/ssr-icon/paths/arrow-level-down';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { withPrefix } from 'gatsby';
import { useCart } from '../contexts/Cart';
import { Item } from './Item';
import TMarkUp from './TMarkUp';

const StyledList = styled(List)`
  margin-bottom: 20px;
`;

const Label = styled.div`
  margin-bottom: 20px;
`;

const Container = styled.div`
  margin-bottom: 20px;
`;

const ReturnLink = styled(Hyperlink)`
  margin-bottom: 20px;
`;

interface Texts {
  label: string;
  linkText: string;
}

const AdditionalItemListing = (texts: Texts): JSX.Element => {
  const cartContext = useCart();
  const items = cartContext.getItems();
  const { t } = useTranslation();
  const url = withPrefix('/');
  const { label, linkText } = texts;

  return (
    <Container>
      <Label>{label}</Label>
      <StyledList>
        {items.map((sparePartItem) => {
          const { item, quantity } = sparePartItem;
          return (
            <Item item={item} key={item.id}>
              <TMarkUp
                value={t('spareParts.summary.items.quantity', { quantity })}
              />
            </Item>
          );
        })}
      </StyledList>
      <ReturnLink url={url} text={linkText}>
        <SSRIcon paths={arrowLevelDown} />
      </ReturnLink>
    </Container>
  );
};

export default AdditionalItemListing;
